<template>
  <router-view/>
</template>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

nav {
  text-align:center;
  padding: 30px;
}

nav a {
  margin: 1%;
  font-weight: bold;
  color: #2c3e50;
}

nav a.router-link-exact-active {
  color: #91bd2a;
}
</style>
